'use strict'

import order from "../order/order";

const createEvent = name => new Event(name);

const detailEvent = createEvent('product.detail');

const bestSellers = document.querySelector('.bestsellers.swiper-container');

const detailTriggers = [...document.querySelectorAll('.shop.overview .product a[data-fancybox]')];

const setDetailListeners = item => {
    detailTriggers.forEach(trigger => {
        trigger.addEventListener('click', _ => {
            document.dispatchEvent(detailEvent);
        })
    })
}

const setBestSellers = element => {
    var initialSlide = Math.ceil((parseInt(element.dataset.count)/2)-1);
    let bestSellerCarrousel = new Swiper(element, {
        initialSlide: initialSlide,
        slidesPerView: 'auto',
        centeredSlides: true, 
        spaceBetween: 30,
        loop: false,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
    });
} 

export default _ => {
    order();
    setDetailListeners();
    if(bestSellers) {
        setBestSellers(bestSellers);
    }
}
